import { styled } from '@mui/system';
import { Button as ButtonMUI} from  "@mui/material";

export const Button = styled(ButtonMUI)`
  margin: 10px;
`;
